import { render, staticRenderFns } from "./PageSizeSelect.vue?vue&type=template&id=5df9bbc0&scoped=true"
import script from "./PageSizeSelect.ts?vue&type=script&lang=ts&external"
export * from "./PageSizeSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./PageSizeSelect.vue?vue&type=style&index=0&id=5df9bbc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df9bbc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df9bbc0')) {
      api.createRecord('5df9bbc0', component.options)
    } else {
      api.reload('5df9bbc0', component.options)
    }
    module.hot.accept("./PageSizeSelect.vue?vue&type=template&id=5df9bbc0&scoped=true", function () {
      api.rerender('5df9bbc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/BillingErrors/components/PageSizeSelect/PageSizeSelect.vue"
export default component.exports